import { Router } from '@angular/router';
import { AiAgentContextService } from '../services/ai-agent-context.service';
import { AiAgentClientTool } from '../types/client-tool.type';

/** Lets the model ask what the user is looking at, instead of guessing from the
 *  conversation. Reports every source, including ones the user removed from the
 *  turn's chips — asking for it is an explicit request. */
export const getCurrentContextTool: AiAgentClientTool<Record<string, never>> = {
  name: 'get_current_context',
  description:
    'Liefert die aktuell geöffnete Route und den sichtbaren Zustand der Anwendung (z.B. gesetzte Filter).',
  parameters: { type: 'object', properties: {} },
  async execute(_args, injector) {
    return {
      route: injector.get(Router).url,
      context: injector.get(AiAgentContextService).all(),
    };
  },
};
